/**
 * The visitor's own calendar day, written into the hidden fields that ask for it.
 *
 * Markup contract: `<input type="hidden" name="…" data-local-today>`. The value is the local date
 * in ISO form (`2026-08-26`) — what a server running on UTC cannot know, and what a day count is
 * wrong by one without: at 20:00 in Denver the server is already on tomorrow.
 *
 * The date is built from the local components rather than from `toISOString()`, which would hand
 * back the UTC day — the very thing this file exists to avoid. Filled on load and left alone: a
 * page that stays open past midnight posts the day it was opened on, which is the day the visitor
 * thinks it is.
 */
function localIsoDate() {
	const now = new Date();
	const pad = (n) => String(n).padStart(2, '0');
	return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
}

document.querySelectorAll('input[data-local-today]').forEach((input) => {
	input.value = localIsoDate();
});
